import logger from '~/utils/logger/logger';

type Listener = () => void;

declare global {
  interface Window {
    gm_authFailure?: () => void;
  }
}

let authFailed = false;
const listeners = new Set<Listener>();

const markAuthFailed = () => {
  if (authFailed) {
    return;
  }
  authFailed = true;
  logger.warn('maps', `Google Maps rejected the API key for ${window.location.origin}`);
  listeners.forEach((listener) => listener());
};

/**
 * Registers the `gm_authFailure` callback Google Maps invokes when it rejects the API key
 * (missing key, or an origin outside the key's referrer allowlist). Call once before any map mounts.
 */
export const installMapsAuthFailureHandler = () => {
  const previous = window.gm_authFailure;
  window.gm_authFailure = () => {
    markAuthFailed();
    previous?.();
  };
};

export const subscribeMapsAuthFailure = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getMapsAuthFailed = () => authFailed;

export const resetMapsAuthFailure = () => {
  authFailed = false;
  listeners.forEach((listener) => listener());
};
